import { shallowEqual, useSelector } from 'react-redux';

import { CreditHold as SharedCreditHold } from 'src/app/shared/components/CreditHold';
import { CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import type { AppState } from 'src/types/appState';

export const CreditHold = ({ renderAlert }: { renderAlert?: boolean }) => {
  const { userCanPayInvoices } = useSelector(
    (state: AppState) => ({
      userCanPayInvoices: state.session.userCanPayInvoices,
    }),
    shallowEqual,
  );

  const onHandleOutstandingClick = () => {
    const eventData = {
      eventName: CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED,
      objectInteraction: 'credit-hold-outstanding-invoices',
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <SharedCreditHold
      renderAlert={renderAlert}
      userCanPayInvoices={userCanPayInvoices}
      onHandleOutstandingClick={onHandleOutstandingClick}
    />
  );
};
